module.exports = __webpack_public_path__ + "static/media/logo_main.3e1b185f.png";